import { create } from "zustand";
import { persist } from "zustand/middleware";
import { TOperationData } from "../types/operation";
import { TWellData } from "../types/well";

interface WellStore {
	well: TWellData | null;
	setWell: (well: TWellData) => void;
}

export const useWellStore = create<WellStore>()(
	persist(
		(set) => ({
			well: null,
			setWell: (well: TWellData) => set({ well }),
		}),
		{
			name: "well-store",
		}
	)
);
